import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from '../../../components/Seo';

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { GetCourseWidget } from '../../../components/GetCourseWidget';
import { FooterFull } from '../../../components/FooterFull';
import { HeaderLogoAndTel } from '../../../components/HeaderLogoAndTel';
import { AdvanceRocket } from '../../../components/AdvanceRocket';
import { WebDate } from '../../../components/WebDate';

import * as main from './style/main.module.scss';
import * as screen1 from './style/screen1.module.scss';
import * as dream from './style/dream.module.scss';
import * as program from './style/program.module.scss';
import * as speaker from './style/speaker.module.scss';
import * as revs from './style/revs.module.scss';
import * as reg from './style/reg.module.scss';
const Screen1 = ({ id }) => {
  return (
    <section className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel />
        <div className={screen1.info}>
          <div className={screen1.dateWrap}>
            <div className={screen1.date}>
              <WebDate id={id} />
            </div>
            <div className={screen1.type}>
              <p>Бесплатный вебинар</p>
            </div>
          </div>
          <h1 className={main.title}>Как воспитать самостоятельного ребёнка</h1>
          <a className={main.btn} href="#widget">
            Хочу на вебинар
          </a>
        </div>
      </div>
    </section>
  );
};
const Dream = () => {
  return (
    <section className={dream.dream}>
      <div className={`container ${dream.container}`}>
        <div className={dream.info}>
          <h2>О чем мечтают многие родители школьников?</h2>
          <p className={dream.desc}>
            Прийти с работы и увидеть, что вся <span className={dream.purpleBg}>домашка сделана</span>,{' '}
            <span className={dream.yellowBg}>рюкзак</span> на завтра <span className={dream.yellowBg}>собран</span>,
            а вместо гаджетов и бесконечных "видосиков" <span className={dream.orangeBg}>ребёнок выбрал книгу</span>.
          </p>
          <h3>Вы тоже этого хотите?</h3>
          <p className={dream.desc}>
            Регистрируйтесь вебинар, на котором мы расскажем вам, как решить проблемы с обучением ребёнка раз и навсегда
          </p>
          <a className={main.btn} href="#widget">
            Прийти на вебинар
          </a>
        </div>
        <img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/e/photo-rus-01.png" alt="" />
      </div>
    </section>
  );
};
const Program = () => {
  return (
    <section className={program.program}>
      <div className="container">
        <h2>Программа вебинара:</h2>
        <ul className={program.blocks}>
          <li className={program.yellow}>
            <p className={program.desc}>
              Как построить процесс обучения в школе и дома, чтобы хватало времени на детство
            </p>
            <ul className={program.itemList}>
              <li>Что делать с ребёнком, который ничего не хочет</li>
              <li>Что убивает самостоятельность: онлайн курсы, родители или школа</li>
            </ul>
          </li>
          <li className={program.purple}>
            <p className={program.desc}>Конкретные технологии ускорения обучения до 10 раз</p>
            <ul className={program.itemList}>
              <li>Пошаговый алгоритм предметов</li>
            </ul>
          </li>
          <li className={program.orange}>
            <p className={program.desc}>Как решить все проблемы с любым обучением раз и навсегда</p>
            <ul className={program.itemList}>
              <li>Как сэкономить свои нервы, время и деньги на репетитора</li>
              <li>Как помочь ребенку увлечься нелюбимым предметом и учёбой в целом</li>
              <li>Как свободно заговорить на английском языке до выпускных экзаменов</li>
            </ul>
          </li>
          <li className={program.blue}>
            <p className={program.desc}>Пошаговый план обеспечения успешного будущего ребёнка</p>
            <ul className={program.itemList}>
              <li>Как правильно договариваться с ребёнком</li>
              <li>Как помочь выбрать будущую профессию</li>
            </ul>
          </li>
        </ul>
        <a className={main.btn} href="#widget">
          Зарегистрироваться
        </a>
      </div>
    </section>
  );
};
const Speaker = () => {
  return (
    <section className={speaker.speaker}>
      <div className={`container ${speaker.container}`}>
        <img src="https://fs.advance.ru/landing-pages/webinar/5_shagov_dlja_rebenka_dz/e/circle-nya.png" alt="" />
        <div>
          <h2>Спикер</h2>
          <p className={speaker.name}>Николай Ягодкин</p>
          <p className={speaker.desc}>специалист по инновационным методикам обучения и изучению иностранных языков</p>
          <ul>
            <li>получил высшие педагогические образования по математике и информатике;</li>
            <li>
              разработал программы «Учись Учиться», которые рекомендует навигатор от министерства Просвещения и
              внедряются в десятках государственных школ России;
            </li>
            <li>написал энциклопедию детской мотивации;</li>
            <li>консультирует министров образования, обучает парламенты зарубежных стран и семьи глав государств;</li>
            <li>
              основал образовательный центр Advance, в котором прошли полное обучение более 85 000 человек по всему
              миру;
            </li>
            <li>получил более 35 000 отзывов о результатах своих программ.</li>
          </ul>
        </div>
      </div>
    </section>
  );
};
const Revs = () => {
  const reviews = [
    {
      id: 1,
      author: 'Андрей Лондарев',
      text: 'Спасибо за демонстрационный материал. Сегодня ребёнок ещё раз убедился, что стоит продолжать заниматься. Сверстники уже завидуют - ещё дополнительная мотивация. Скоро подойдем к составлению договора. Ребёнок активно отрабатывает навык «постановки нового навыка». Запомнил ряд элементов таблицы Менделеева. Сказал: тю! Требует ещё... Деньги потрачены не зря. Всем советую присоединяться!',
      classname: `${revs.yellow}`,
    },
    {
      id: 2,
      author: 'София Белова',
      text: 'Спасибо за обучение! Очень мощно, ёмко, образно, структурировано! Очень довольна, этим обучением, оно оправдывает вложенные средства на 1000%. Понравилась поддержка в чате и на вебинарах- все вопросы разбирались до полного понимания. Все материалы остались в доступе. Теперь дело за малым- продолжать самостоятельно внедрять новое умение в свою жизнь и приобщать к нему детей. Спасибо всей команде!',
      classname: `${revs.purple}`,
    },
    {
      id: 3,
      author: 'Анастасия Федосеева',
      text: 'Вы вдохновляете, а материал подаете интересно, с юмором. Теперь я знаю, как эффективно готовиться к экзаменам, а мне, как ученице 11 класса, эти навыки очень кстати:) Как хорошо, что я учусь по новым технологиям еще в школе;) В итоге передо мной открываются огромные перспективы: легкое и эффективное обучение, свободное владение ин.языками - столько, сколько захочу:) , подготовка к экзамену за меньшие сроки и с лучшими результатами. P.S. Это мое ЛУЧШЕЕ ВЛОЖЕНИЕ ДЕНЕГ!:)',
      classname: `${revs.orange}`,
    },
  ];
  const [isReadMore, setIsReadMore] = React.useState(-1);
  const btnClickShow = (index) => {
    setIsReadMore(index);
  };
  const btnClickHide = () => {
    setIsReadMore(-1);
  };
  return (
    <section className={revs.revs}>
      <div className="container">
        <h2>Отзывы о курсах Advance для детей:</h2>
        <ul>
          {reviews.map((elem, index) => (
            <li className={elem.classname} key={index}>
              <h3>{elem.author}</h3>
              <p>{isReadMore === index ? elem.text : `${elem.text.slice(0, 150)}...`}</p>
              <button
                onMouseDown={() => {
                  btnClickShow(index);
                }}
                onMouseUp={btnClickHide}
              >
                {isReadMore === index ? 'Свернуть' : 'Читать далее'}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
const Reg = ({ widget, id }) => {
  return (
    <section className={reg.reg}>
      <div className="container">
        <div className={reg.inner}>
          <div className={reg.desc}>
            <p className={reg.title}>Успей занять свое место!</p>
            <time className={reg.time}>
              <WebDate id={id} />
            </time>
            <h3 className={reg.title}>
              Вебинар <br />
              «Как воспитать самостоятельного ребёнка»
            </h3>
          </div>
          <div className={reg.widget} id={'widget'}>
            {widget}
          </div>
        </div>
      </div>
    </section>
  );
};
const TITLE =
  'Бесплатный вебинар “5 шагов, чтобы ребенок учился сам, перестал мучиться с домашними заданиями и мучить вас” от Advance';
const DESCRIPTION =
  'Узнайте 5 простых шагов для того, чтобы ребенок учился самостоятельно, не мучился с домашними заданиями и перестал мучить вас на бесплатном вебинаре от центра образовательных технологий Advance.';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = ({ widget = <GetCourseWidget hash={'078e638916c4b4ddb88f6bd8c57fd0964db7cab0'} id={'556719'} /> }) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1 id={'rus_e'} />
      <Dream />
      <Program />
      <Speaker />
      <Revs />
      <AdvanceRocket />
      <Reg id={'rus_e'} widget={widget} />
    </main>

    <FooterFull />
  </DefaultLayout>
);
export default Page;
